const filterWithCase = (stringToFilter, filter, matchCase) => matchCase
    ? stringToFilter.includes(filter)
    : stringToFilter.toLowerCase().includes(filter.toLowerCase());
const filterWithString = (stringToFilter, filter, filterOptions) => filterOptions?.regularExpression
    ? stringToFilter.match(filter) !== null
    : filterWithCase(stringToFilter, filter, filterOptions?.matchCase);
const filterCaption = (item, filterInfo) => !filterInfo.filter ||
    filterWithString(item.caption ?? item.value, filterInfo.filter, filterInfo.options);
const computeFilter = (item, filterInfo) => filterInfo.options?.hideMatchesAndShowNonMatches === true
    ? !filterCaption(item, filterInfo)
    : filterCaption(item, filterInfo);
export const filterSubModel = (item, filterInfo, displayedValues) => {
    // Check if a subitem is rendered
    let aSubItemIsRendered = false;
    const itemSubGroup = item.items;
    if (itemSubGroup != null) {
        for (let index = 0; index < itemSubGroup.length; index++) {
            const itemLeaf = itemSubGroup[index];
            const itemSatisfiesFilter = filterSubModel(itemLeaf, filterInfo, displayedValues);
            aSubItemIsRendered ||= itemSatisfiesFilter;
        }
    }
    // The current item is rendered if it satisfies the filter condition or a
    // subitem exists that needs to be rendered
    const satisfiesFilter = aSubItemIsRendered || computeFilter(item, filterInfo);
    // Update selected and checkbox items
    if (satisfiesFilter) {
        displayedValues.add(item);
    }
    return satisfiesFilter;
};
